import { render, staticRenderFns } from "./alert-selector.vue?vue&type=template&id=55344077&scoped=true"
import script from "./alert-selector.vue?vue&type=script&lang=js"
export * from "./alert-selector.vue?vue&type=script&lang=js"
import style0 from "./alert-selector.vue?vue&type=style&index=0&id=55344077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55344077",
  null
  
)

export default component.exports